import Link from 'next/link';
import Image from 'next/image';

import scaleLogo from 'react-scale/public/static/images/pages/guides/scale-logo.svg';

import style from './guides-list.module.css';

const GuidesList = ({ items, title = '' }) => (
  <div className="container py-28">
    {title && <h2 className="mb-8 text-4xl">{title}</h2>}
    <ul className="flex flex-wrap items-center justify-start gap-8 list-none">
      {items.map(item => (
        <li key={item.data.id}>
          <Link href={item.data.url} className={style.book}>
            <div className={style.bookCover}>
              <div className="absolute inset-0 text-left">
                <div className="flex flex-auto px-8 py-6">
                  <Image src={scaleLogo} alt="Scale logo" />
                </div>
                <div className="absolute z-10 flex items-center justify-center w-12 h-12 text-base italic text-white rounded-full top-10 right-6 bg-black/60">
                  #{item.data.guideNumber}
                </div>
                <div className="relative flex flex-auto h-64">
                  <Image
                    src={`/static/images/pages/guides/gradient/gradient-${item.data.guideNumber}.svg`}
                    alt={`gradient guide ${item.data.guideNumber}`}
                    fill
                    objectFit="cover"
                    quality={100}
                    loading="eager"
                  />
                  <p className="absolute top-0 py-6 pl-8 pr-2 text-4xl font-medium uppercase font-manuka">
                    {item.data.title}
                  </p>
                </div>
                <div className="px-8 py-4 text-sm">{item.data.category.value?.name}</div>
              </div>
              <div className="relative w-2 h-full bg-gradient-to-r from-white/0 to-black/5" />
              <div className={style.effect} />
              <div className={style.light} />
            </div>
            <div className={style.bookInside} />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default GuidesList;
